import store from '../../store/store';
import { runWorkflow } from '../../api/workflow/runWorkflow';
import { openNewWorkspace } from '../../store/workspaces/workspaces/actions';
import { runStaticQuery } from '../../api/query/run.staticQuery';
import { TabService } from '../../api/services/workspaces/Service.tab'; 
import { WorkspaceService } from '../../api/services/workspaces/Service.workspace';
import { setWorkspaceGroups } from '../../store/workspaces/workspaces/actions';

export const newTab = async () => {
  const response = await runStaticQuery('workspace', null);
  const onLoadEvent = response.workspace.events.find((event) => event?.type === 'onLoad');

  if (onLoadEvent) {
    const key = onLoadEvent.key;
    const response = await runWorkflow(key, null, {}, null, true);
    await store.dispatch(openNewWorkspace(response, 'modules'));
  }

  setTimeout(async () => {
    const { instances, groups } = store.getState().workspaces;
    const currentTab = instances.at(-1);
    const currentUUID = JSON.parse(localStorage.getItem('activeWorkspace') || '{}')?.uuid;

    const updatedTabs = [...(groups.find(g => g.uuid === currentUUID)?.tabs || []), currentTab.uuid];
    const updatedGroups = groups.map(g =>
      g.uuid === currentUUID ? { ...g, tabs: updatedTabs } : g
    );
    const currentGroup = groups.find(g => g.uuid === currentUUID);

    const workspace = store.getState().workspaces.instances[instances.length - 1];

    const tabService = new TabService(currentGroup);
    await tabService.setTab(workspace); 

    const workspaceService = new WorkspaceService();
    await workspaceService.update(currentGroup); 

    await store.dispatch(setWorkspaceGroups(updatedGroups));
  }, 500);
};
